/* global document, window */

/**
 * Product archive filter form behavior.
 *
 * The filter form (sidebar `[data-pa-filter-form]`) submits via GET to the
 * archive base URL (its `action` attribute already strips any `/page/N/`
 * pagination segment), so every submission lands on page 1 of the new
 * result set. The PHP `pre_get_posts` hook reads the params and pre-filters
 * the WC query. This script just auto-submits on changes so users don't
 * need a manual "Apply" button.
 *
 * - Checkbox change -> submit immediately.
 * - Search input    -> submits only on Enter or the search button (native GET
 *   form submit). It intentionally does NOT search while the user is typing.
 * - "Clear all" link is plain HTML; no JS handler needed.
 * - Filters toggle  -> on mobile (≤900px, CSS-only) the filter groups start
 *   collapsed behind a "Filters" button. If a checkbox submits the form while
 *   the panel is open, it's reopened on the reloaded page so users can keep
 *   ticking boxes without re-expanding it every time.
 */
( function () {
	const OPEN_KEY = 'pa-filters-open';

	const storage = {
		take() {
			try {
				const value = window.sessionStorage.getItem( OPEN_KEY );
				window.sessionStorage.removeItem( OPEN_KEY );
				return value === '1';
			} catch ( e ) {
				return false;
			}
		},
		set() {
			try {
				window.sessionStorage.setItem( OPEN_KEY, '1' );
			} catch ( e ) {
				// Storage unavailable — panel just starts collapsed.
			}
		},
	};

	const onReady = ( fn ) => {
		if ( document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	};

	const init = () => {
		const forms = document.querySelectorAll( '[data-pa-filter-form]' );
		if ( ! forms.length ) {
			return;
		}

		const reopen = storage.take();

		forms.forEach( ( form ) => {
			const sidebar = form.closest( '.pa-sidebar' );
			const toggle = form.querySelector( '[data-pa-filter-toggle]' );

			const setOpen = ( open ) => {
				sidebar.classList.toggle( 'is-collapsed', ! open );
				toggle.setAttribute( 'aria-expanded', String( open ) );
			};

			if ( sidebar && toggle ) {
				if ( reopen ) {
					setOpen( true );
				}
				toggle.addEventListener( 'click', () => {
					setOpen( sidebar.classList.contains( 'is-collapsed' ) );
				} );
			}

			form.querySelectorAll( 'input[type="checkbox"]' ).forEach( ( cb ) => {
				cb.addEventListener( 'change', () => {
					if ( sidebar && ! sidebar.classList.contains( 'is-collapsed' ) ) {
						storage.set();
					}
					form.submit();
				} );
			} );

			// The search input intentionally has NO input/keyup handler, so it
			// does not search while typing. Enter and the search button submit
			// the GET form natively, which is the only thing that triggers a
			// search.
		} );
	};

	onReady( init );
}() );
